import classnames from 'classnames';
import { useRef, useState } from 'react';
import { useUnmount } from 'react-use';
import { $a } from 'shared-base';
import IconButton from '../IconButton/IconButton';
import { Button, Content, Cta, Wrapper } from './EditorsChoice.style';
import { arr } from './EditorsChoice.utils';

export type EditorsChoiceProps = {
  total: number;
  onAction: OnAction;
  onClick?: (index: number) => void;
  slim?: boolean;
};

export function EditorsChoice(props: EditorsChoiceProps) {
  const { slim } = props;
  const ref = useRef<any>();
  const { total = 0 } = props;
  const [disabled, setDisabled] = useState(false);

  function onStar() {
    const sequence = total + 1;
    props.onAction($a('GOLDEN', 'save', '', { sequence }));
    setDisabled(true);
    ref.current = setTimeout(() => setDisabled(false), 2000);
  }

  useUnmount(() => {
    if (!ref.current) return;
    clearTimeout(ref.current);
  });

  function onClick(index: number) {
    if (props.onClick) {
      props.onClick(index);
      return;
    }

    props.onAction($a('GOLDEN', 'load', '', { index }));
  }

  function renderButton(index: number) {
    const disabled = total <= index;

    return (
      <Button onClick={() => onClick(index)} key={index} className='index' disabled={disabled}>
        {index + 1}
      </Button>
    );
  }

  function renderButtons() {
    const len = slim ? total : 16;
    return arr(len).map((index: number) => renderButton(index));
  }

  const className = classnames('EditorsChoice-wrapper', {
    slim,
  });

  return (
    <Wrapper className={className} data-testid='EditorsChoice-wrapper'>
      <Cta className='cta'>
        <IconButton disabled={disabled} name='IconStar' onClick={onStar} />
      </Cta>
      <Content>{renderButtons()}</Content>
    </Wrapper>
  );
}

export default EditorsChoice;
